const OUTLOOK_DOMAINS = [
  "hotmail.com",
  "hotmail.co.uk",
  "live.com",
  "msn.com",
  "outlook.com",
  "outlook.co.uk"
];
const GMAIL_DOMAINS = ["googlemail.com", "gmail.com"];

export function getEmailAppData(email: string) {
  const provider = getProvider(email);

  if (!provider) return;

  if (provider === "gmail") {
    const link = getGmailLink(email);
    return { link, text: "Open in Gmail" };
  }

  if (provider === "outlook") {
    const link = getOutlookLink(email);
    return { link, text: "Open in Outlook" };
  }
}

function getProvider(email: string) {
  const domain = email.toLowerCase().split("@")[1];

  if (GMAIL_DOMAINS.includes(domain)) return "gmail";

  if (OUTLOOK_DOMAINS.includes(domain)) return "outlook";

  return;
}

const SENDER_EMAIL = "no-reply@senecalearning.com";
const EMAIL_SUBJECT = "Sign in to Seneca";

function getGmailLink(email: string) {
  const from = encodeURIComponent(`from:${SENDER_EMAIL}`);
  const subject = encodeURIComponent(`subject:${EMAIL_SUBJECT}`);
  const inFolder = encodeURIComponent("in:anywhere");
  const dateFilter = encodeURIComponent("newer_than:1d");

  return `https://mail.google.com/mail/u/${email}/#search/${from}+${subject}+${inFolder}+${dateFilter}`;
}

function getOutlookLink(email: string) {
  const encodedEmail = encodeURIComponent(email);
  return `https://outlook.live.com/mail/?login_hint=${encodedEmail}`;
}
